export default __webpack_public_path__ + "static/media/masjid img 5.bd4991df.jpg";